import type { ReactNode } from 'react'
import { Tag, Typography } from 'antd'
import type { OrderListAuditRow, OrderListBaseRow, OrderStatusMap } from './order-list-types.ts'

export function OrderNumberGroupCell({
  orderNo,
  orderGroupName,
  orderNumber,
  orderGroup
}: Pick<OrderListBaseRow, 'orderNo' | 'orderGroupName'> & {
  orderNumber?: ReactNode
  orderGroup?: ReactNode
}) {
  return (
    <div className="min-w-0">
      <div className="flex min-w-0 items-center gap-1">
        <div className="min-w-0 truncate font-semibold">{orderNumber ?? orderNo}</div>
        <Typography.Text copyable={{ text: orderNo }} className="shrink-0" />
      </div>
      <Typography.Text className="block text-xs!" ellipsis type="secondary">
        {orderGroup ?? (orderGroupName || '未加入订单组')}
      </Typography.Text>
    </div>
  )
}

export function OrderCustomerCell({
  customerName,
  children
}: Pick<OrderListBaseRow, 'customerName'> & { children?: ReactNode }) {
  return (
    <Typography.Text className="font-medium" ellipsis={{ tooltip: customerName }}>
      {children ?? (customerName || '—')}
    </Typography.Text>
  )
}

export function OrderSubjectCell({
  primary,
  secondary,
  primaryFallback = '未关联对象',
  secondaryFallback = '未关联法人'
}: {
  primary?: string | null
  secondary?: string | null
  primaryFallback?: string
  secondaryFallback?: string
}) {
  return (
    <div className="flex min-w-0 flex-col gap-1">
      <Typography.Text className="w-full" ellipsis={{ tooltip: primary || primaryFallback }} strong>
        {primary || primaryFallback}
      </Typography.Text>
      {secondary !== undefined && (
        <Typography.Text className="w-full" ellipsis={{ tooltip: secondary || secondaryFallback }} type="secondary">
          {secondary || secondaryFallback}
        </Typography.Text>
      )}
    </div>
  )
}

export function OrderNoteCell({ note }: Pick<OrderListAuditRow, 'note'>) {
  return <Typography.Text ellipsis>{note?.trim() || '—'}</Typography.Text>
}

export function OrderStatusTag<TStatus extends string>({
  status,
  statusMap,
  archivedAt
}: {
  status: TStatus
  archivedAt?: Date | null
  statusMap: OrderStatusMap<TStatus>
}) {
  const option = statusMap[status]
  return (
    <div className="flex flex-wrap gap-1">
      <Tag color={option.color ?? 'default'}>{option.text}</Tag>
      {archivedAt && status !== 'archived' && <Tag>已归档</Tag>}
    </div>
  )
}
